import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'

type Props = {
  isShown: boolean
  children: React.ReactNode
}

export const Dialog = ({ isShown, children }: Props) => {
  const shouldAnimate = !useReducedMotion()

  const containerAnimationOptions = useState({
    initial: shouldAnimate ? { opacity: 0, translateY: '-20%' } : {},
    animate: shouldAnimate ? { opacity: 1, translateY: '0%' } : {},
    exit: shouldAnimate ? { opacity: 0, translateY: '-20%' } : {}
  })

  const modalAnimationOptions = useState({
    initial: shouldAnimate ? { opacity: 0, translateY: '20%' } : {},
    animate: shouldAnimate ? { opacity: 1, translateY: '0%' } : {},
    exit: shouldAnimate ? { opacity: 0, translateY: '20%' } : {}
  })

  return ReactDOM.createPortal(
    <AnimatePresence mode="wait">
      {isShown && (
        <motion.div className="dialog-overlay" {...containerAnimationOptions}>
          <motion.div {...modalAnimationOptions} className="dialog-content">
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.getElementById('root') as HTMLDivElement
  )
}
